import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import {
  Layout,
  Form,
  Input,
  Button
} from 'antd'
import { Container, Col, Row, Card, CardHeader } from 'reactstrap'
import Header from '../Header'
import History from './History'
import API from '../../api/index'

class MaintenanceDetail extends Component {
  constructor (props) {
    super(props)
    this.initialState = {
      id: props.match.params.id,
      typeRequirement: undefined,
      status: undefined,
      observation: undefined,
      user: undefined,
      documents: [],
      errorDocuments: undefined,
      redirect: undefined,
      fullName: undefined,
      date: undefined
    }
    this.state = this.initialState
    this.onBack = this.onBack.bind(this)
  }

  updateState (key, value) {
    this.setState({
      [key]: value
    })
  }

  async onBack () {
    this.updateState('redirect', '/maintenance')
  }

  getMonth (index) {
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    return months[index]
  }

  formatDate (date) {
    const newDate = new Date(date)
    return ('0' + (newDate.getDate())).slice(-2) + ' de ' + this.getMonth(newDate.getMonth()) + ' del ' + newDate.getFullYear() + ', ' + ('0' + newDate.getHours()).slice(-2) + ':' + ('0' + newDate.getMinutes()).slice(-2)
  }

  async getMaintenance () {
    const maintenance = await API.maintenance.detail(this.state.id)
    if (maintenance._id) {
      this.setState({
        typeRequirement: maintenance.typeRequirement.name,
        status: maintenance.status,
        observation: maintenance.observation,
        documents: maintenance.documents,
        fullName: `${maintenance.user.firstName} ${maintenance.user.lastName}`,
        date: this.formatDate(maintenance.created)
      })
    } else {
      this.onBack()
    }
  }

  componentDidMount () {
    this.getMaintenance()
  }

  render () {
    let documents = []
    this.state.documents.map((value, index) => {
      documents.push(<ul key={index}><li><a href={`https://api.oftalmolasersa.com.co/${value[0]}`}>{value[0]}</a></li></ul>)
    })
    if (this.state.redirect) {
      return (<Redirect to={this.state.redirect} />)
    }
    return (
      <Layout className='layout'>
        <Header item='maintenance' />
        <div className='main-content' ref='mainContent'>
          <Container fluid>
            <Row className='mt-5 mb-5'>
              <Col className='mb-5 mb-xl-0' xl='12'>
                <Card className='shadow content-auto'>
                  <CardHeader className='border-0'>
                    <Row className='align-items-center'>
                      <div className='col'>
                        <h3 className='mb-0'>Detalle de la solicitud de requerimiento</h3>
                      </div>
                      <div className='col text-right'>
                        <Button onClick={this.onBack}>Regresar</Button>
                      </div>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Item label='Tipo de requerimiento'>
                          <Input
                            type='text'
                            disabled
                            value={this.state.typeRequirement}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label='Estado de solicitud'>
                          <Input
                            type='text'
                            disabled
                            value={this.state.status}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label='Usuario que reporta'>
                          <Input
                            type='text'
                            disabled
                            value={this.state.fullName}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Item label='Fecha de reporte'>
                          <Input
                            type='text'
                            disabled
                            value={this.state.date}
                          />
                        </Form.Item>
                      </Col>
                      {documents.length > 0 && (
                        <Col span={7} offset={1}>
                          <Form.Item
                            label='Documentos'
                          >
                            {documents}
                          </Form.Item>
                        </Col>
                      )}
                      <Col>
                        <Form.Item label='Observación'>
                          <Input.TextArea
                            rows={6}
                            disabled
                            value={this.state.observation}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <History id={this.state.id} />
                  </CardHeader>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    )
  }
}

export default MaintenanceDetail
